import React from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { useTranslation } from 'react-i18next';
import PaymentComplementRow from './PaymentComplementRow';

const PaymentComplementsList = ({
  complements,
  onViewPdf,
  onSendToClient,
  onAssociateContract
}) => {
  const { t } = useTranslation();

  if (!complements.length) {
    return (
      <Box sx={{ padding: '28px 20px', color: '#7a838e', fontSize: '13px' }}>
        {t('TRANSACTION.DETAIL.NO_PAYMENTS_REGISTERED')}
      </Box>
    );
  }

  return (
    <Box sx={{ display: 'grid' }}>
      {complements.map(complement => (
        <PaymentComplementRow
          key={complement.id}
          {...complement}
          onViewPdf={onViewPdf}
          onSendToClient={onSendToClient}
          onAssociateContract={onAssociateContract}
        />
      ))}
    </Box>
  );
};

PaymentComplementsList.propTypes = {
  complements: PropTypes.array.isRequired,
  onViewPdf: PropTypes.func.isRequired,
  onSendToClient: PropTypes.func.isRequired,
  onAssociateContract: PropTypes.func.isRequired
};

export default PaymentComplementsList;
